export const DEFUALT_COLUMNS = ['spec_concat', 'card_no', 'defect_no', 'compliance_count', 'raw_findings_rate',
    'total_effort_hours', 'total_labor_cost_max', 'fec','yield_percentage','mntc_check',  'mntc_check_interval','wpm_score', 'rank', 'spec_type',
    'mntc_check_package',
    'mntc_check_package_interval', 'comments', 'assigned_to']

export const keyLabelMap = {
    'spec_concat': 'Spec No.',
    'card_no': 'Card No.',
    'defect_no': 'Defect Count',
    'compliance_count': 'Compliance Count',
    'raw_findings_rate': 'Raw Finding Rate',
    'total_effort_hours': 'Total Effort Hours',
    'total_labor_cost_max': 'Approx. life-time labor Cost',
    'yield_percentage': 'Yield %',
    'mntc_check': 'Maintenance Check',
    'mntc_check_interval': 'Maintenance Check Interval',
    'fec': 'FEC',
    'wpm_score': 'Rank Score',
    'rank': 'Rank',
    'mntc_check_package': 'Maintenance Check Package',
    'mntc_check_package_interval': 'Maintenance Check Package Interval',
    'assigned_to': 'Assigned To',
};

export const checkboxData = [
    { label: 'Select All', value: 'all' },
    { label: 'Spec No.', value: 'spec_concat' },
    { label: 'Card No.', value: 'card_no' },
    { label: 'Defect Count', value: 'defect_no' },
    { label: 'Compliance Count', value: 'compliance_count' },
    { label: 'Raw Finding Rate', value: 'raw_findings_rate' },
    { label: 'Total Effort Hours', value: 'total_effort_hours' },
    { label: 'Approx. life-time labor Cost', value: 'total_labor_cost_max' },
    { label: 'Yield %', value: 'yield_percentage' },
    { label: 'Maintenance Check', value: 'mntc_check' },
    { label: 'Maintenance Check Interval', value: 'mntc_check_interval' },
    { label: 'FEC', value: 'fec' },
    { label: 'Rank Score', value: 'wpm_score' },
    { label: 'Rank', value: 'rank' },
    { label: 'Spec Type', value: 'spec_type' },
    { label: 'Maintenance Check Package', value: 'mntc_check_package' },
    { label: 'Maintenance Check Package Interval', value: 'mntc_check_package_interval' },
    { label: 'Comments', value: 'comments' },
    { label: 'Assigned To', value: 'assigned_to' },
];
export const REQUIRED_COLUMNS = [
  "spec_type",
  "card_no",
  "rank",
  "status",
  "assigned_to",
  "comments"
];
export const mntcCheck = [
  { label: "A-Check", value: "A-Check" },
  { label: "B-Check", value: "B-Check" },
  { label: "C-Check", value: "C-Check" },
  { label: "D-Check", value: "D-Check" },
  { label: "E-Check", value: "E-Check" },
  { label: "F-Check", value: "F-Check" }
];
export const mntcCheckPackage = [
  { label: "1C", value: "1C" },
  { label: "2C", value: "2C" },
  { label: "3C", value: "3C" },
  { label: "4C", value: "4C" },
  { label: "5C", value: "5C" }
];
export const mntcCheckInterval = [
  { label: "1 Month", value: "1 months" },
  { label: "2 Months", value: "2 months" },
  { label: "3 Months", value: "3 months" },
  { label: "4 Months", value: "4 months" },
  { label: "5 Months", value: "5 months" },
  { label: "6 Months", value: "6 months" },
  { label: "7 Months", value: "7 months" },
  { label: "8 Months", value: "8 months" },
  { label: "9 Months", value: "9 months" },
  { label: "10 Months", value: "10 months" },
  { label: "11 Months", value: "11 months" },
  { label: "12 Months", value: "12 months" },
  { label: "13 Months", value: "13 months" },
  { label: "14 Months", value: "14 months" },
  { label: "15 Months", value: "15 months" },
  { label: "16 Months", value: "16 months" },
  { label: "17 Months", value: "17 months" },
  { label: "18 Months", value: "18 months" },
  { label: "19 Months", value: "19 months" },
  { label: "20 Months", value: "20 months" },
  { label: "21 Months", value: "21 months" },
  { label: "22 Months", value: "22 months" },
  { label: "23 Months", value: "23 months" },
  { label: "24 Months", value: "24 months" },
  { label: "25 Months", value: "25 months" },
  { label: "26 Months", value: "26 months" }
];
export const mntcCheckPackageInterval = [
  { label: "1 Month", value: "1 months" },
  { label: "2 Months", value: "2 months" },
  { label: "3 Months", value: "3 months" },
  { label: "4 Months", value: "4 months" },
  { label: "5 Months", value: "5 months" },
  { label: "6 Months", value: "6 months" },
  { label: "7 Months", value: "7 months" },
  { label: "8 Months", value: "8 months" },
  { label: "9 Months", value: "9 months" },
  { label: "10 Months", value: "10 months" },
  { label: "11 Months", value: "11 months" },
  { label: "12 Months", value: "12 months" },
  { label: "13 Months", value: "13 months" },
  { label: "14 Months", value: "14 months" },
  { label: "15 Months", value: "15 months" },
  { label: "16 Months", value: "16 months" },
  { label: "17 Months", value: "17 months" },
  { label: "18 Months", value: "18 months" },
  { label: "19 Months", value: "19 months" },
  { label: "20 Months", value: "20 months" },
  { label: "21 Months", value: "21 months" },
  { label: "22 Months", value: "22 months" },
  { label: "23 Months", value: "23 months" },
  { label: "24 Months", value: "24 months" },
  { label: "25 Months", value: "25 months" },
  { label: "26 Months", value: "26 months" }
];